import {ColumnsType} from 'antd/lib/table/Table';
import {Dropdown, Menu} from 'antd';
import IntlMessages from '../../../../../../domain/utility/IntlMessages';
import {BsCheckLg, BsXLg} from 'react-icons/bs';
import {AiFillDelete, AiFillEdit} from 'react-icons/ai';
import {DistrictsListDto} from 'src/shared/services/configuration/countries/dtos/districts-list-dto';
import MainUtils from 'src/shared/utils/main';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import RowActionsButton from 'src/shared/components/row-actions';

const TableColumn = (
  deleteDistrict: Function,
  updateDistrict: Function,
): ColumnsType<any> => {
  const {locale}: any = useLocaleContext();
  return [
    {
      title: <IntlMessages id='common.name' />,
      dataIndex: 'Name',
      key: 'Name',
      width: '30%',
      render: (value: string, record: DistrictsListDto) => {
        return (
          record?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? value
        );
      },
    },
    {
      title: <IntlMessages id='manageShops.code' />,
      dataIndex: 'Code',
      key: 'Code',
      width: '20%',
      render: (value) => (!MainUtils.isEmptyValue(value) ? value : ''),
    },
    {
      title: <IntlMessages id='orders.shippingCost' />,
      dataIndex: 'ShippingCost',
      key: 'ShippingCost',
      className: 'col-num',
      width: '20%',
      render: (value) => (!MainUtils.isEmptyValue(value) ? value : 0),
    },
    {
      title: <IntlMessages id='countries.DisplayOrder' />,
      dataIndex: 'DisplayOrder',
      key: 'DisplayOrder',
      className: 'col-num',
      width: '20%',
      render: (value) => (!MainUtils.isEmptyValue(value) ? value : 0),
    },
    {
      title: <IntlMessages id='countries.Published' />,
      render: (value) =>
        value ? <BsCheckLg color='green' /> : <BsXLg color='red' />,
      dataIndex: 'Published',
      key: 'Published',
      width: '20%',
      className: 'col-center',
    },
    {
      title: <IntlMessages id='common.Action' />,
      render: (text: string, item: DistrictsListDto) => {
        return (
          <div>
            <Dropdown
              trigger={['click']}
              overlay={() => (
                <Menu>
                  <Menu.Item key={'edit'} onClick={() => updateDistrict(item)}>
                    <AiFillEdit className='icon-in-action' />
                    <span className='margin-in-action'>
                      <IntlMessages id='category.categoryEdit' />
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    onClick={() => deleteDistrict(item)}
                    key={'delete'}>
                    <AiFillDelete className='icon-in-action' />
                    <span className='margin-in-action'>
                      <IntlMessages id='category.categoryDelete' />
                    </span>
                  </Menu.Item>
                </Menu>
              )}
              placement='bottomRight'>
              <RowActionsButton />
            </Dropdown>
          </div>
        );
      },
      className: 'col-actions',
      width: 80,
    },
  ];
};

export default TableColumn;
